import React, { useState, useRef, useEffect } from 'react';
import { Upload, X } from 'lucide-react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Card, Col, Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import { useLoader } from '../../_helper/LoaderContext';
import { addHeaderFooterValue } from './service/setting-service';
import { toast } from 'react-toastify';
import { useLab } from '../../_helper/PharmacyProvider';
import S3ImageLoader from '../../S3ImageLoader';

export default function HeaderHome() {
    const [logo, setLogo] = useState(null);
    const [logoPreview, setLogoPreview] = useState(null);
    const { setLoading } = useLoader()
    const [headerText, setHeaderText] = useState(``);
    const fileInputRef = useRef(null);

    useEffect(() => {
        const header = JSON.parse(localStorage.getItem("header"))
        if (header.headerLogo !== "") {
            setLogoPreview(`${header.headerLogo}`)
        }
        setHeaderText(header.headerTest)
    }, [])

    const handleLogoUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Check file size (max 2MB)
        if (file.size > 2 * 1024 * 1024) {
            toast.warning("Image must be below 2MB");
            e.target.value = ''; // Clear the input
            return;
        }

        // Check file type - only allow JPG, JPEG, PNG
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
        if (!allowedTypes.includes(file.type)) {
            toast.warning("Only JPG, JPEG, and PNG images are allowed");
            e.target.value = ''; // Clear the input
            return;
        }

        setLogo(file);
        const reader = new FileReader();
        reader.onloadend = () => {
            setLogoPreview(reader.result);
        };
        reader.readAsDataURL(file);
    };

    const removeLogo = () => {
        setLogo(null);
        setLogoPreview(null);
        if (fileInputRef.current) fileInputRef.current.value = '';
    };

    const handelAdd = async () => {
        setLoading(true)
        try {
            const form_data = new FormData();
            form_data.append("headerText", headerText);
            if (logo) {
                form_data.append("logoImg", logo, logo.name);
            }
            // form_data.forEach((key,value) => console.log(key+" :" +value))
            const res = await addHeaderFooterValue(form_data)
            if (res.data.success == true) {
                toast.success(res.data.message);
                // setHeaderText("");
                // setLogo(null);
                const headerFooter = {
                    headerTest: res.data.data.headerText,
                    footerText: res.data.data.footerText,
                    headerLogo: res.data.data.headerLogo
                }
                localStorage.setItem("header", JSON.stringify(headerFooter))
                // setLogoPreview(null)
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <Breadcrumbs mainTitle="Header Setting" parent="Home" title="Header Setting" />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <Card className="tw-p-8">
                            <div className="">
                                {/* COMPACT REALISTIC HEADER PREVIEW - Like on actual report */}
                                <div className="">
                                    <div className="tw-flex tw-items-center tw-justify-between tw-gap-6">
                                        {/* Small Logo */}
                                        <div className="tw-flex-shrink-0">
                                            {logoPreview ? (
                                                <S3ImageLoader
                                                    fileName={logoPreview}
                                                    fallbackSrc={''}
                                                    className="tw-h-[150px] tw-w-[150px] tw-object-contain tw-max-w-48"
                                                    alt="logoPreview" />
                                            ) : (
                                                <div className="tw-h-16 tw-w-32 tw-bg-gray-200 tw-border-2 tw-border-dashed tw-rounded tw-flex tw-items-center tw-justify-center tw-text-gray-400 tw-text-xs">
                                                    No Logo
                                                </div>
                                            )}
                                        </div>

                                        {/* Compact Text - Right Aligned */}
                                        <div className="tw-flex-1 tw-text-right">
                                            <div
                                                className="
                                    tw-w-full
                                    [&>*]:tw-block [&>*]:tw-my-0 [&>*]:tw-leading-tight

                                    /* Inline alignment */
                                    [&_[style*='text-align:left']]:tw-text-left
                                    [&_[style*='text-align:center']]:tw-text-center
                                    [&_[style*='text-align:right']]:tw-text-right
                                    [&_[style*='text-align:justify']]:tw-text-justify

                                    /* Quill alignment classes */
                                    [&_.ql-align-left]:tw-text-left
                                    [&_.ql-align-center]:tw-text-center
                                    [&_.ql-align-right]:tw-text-right
                                    [&_.ql-align-justify]:tw-text-justify
                                "
                                                dangerouslySetInnerHTML={{ __html: headerText }}
                                            />
                                        </div>
                                    </div>

                                    <hr className="tw-mt-4 tw-border-t-2 tw-border-green-700" />
                                    <p className="tw-text-center tw-text-xs tw-text-gray-500 tw-mt-2">Header Preview (as it will appear on reports)</p>
                                </div>

                                {/* EDIT PANELS */}
                                <div className="row">
                                    {/* LOGO UPLOAD */}
                                    <div className="col-md-3">

                                        <h3 className="tw-text-lg tw-font-semibold tw-mb-4 tw-text-gray-700">
                                            Upload Lab Logo
                                        </h3>

                                        {/* Upload Box */}
                                        <div
                                            className="tw-border tw-border-gray-300 tw-rounded-xl tw-bg-white tw-p-6 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-cursor-pointer hover:tw-shadow-md tw-transition-all tw-min-h-[220px]"
                                        >
                                            {/* Preview OR Icon */}
                                            {logoPreview ? (
                                                <S3ImageLoader
                                                    fileName={logoPreview}
                                                    fallbackSrc={''}
                                                    // className="m-0 rounded-circle border border-5 border-white shadow-lg"
                                                    alt="logoPreview"
                                                    style={{ width: "100%", height: "100px", objectFit: "contain" }} />
                                            ) : (
                                                <div className="tw-flex tw-flex-col tw-items-center tw-text-center tw-text-gray-500">
                                                    <Upload className="tw-w-10 tw-h-10 tw-text-gray-400" />
                                                    <p className="tw-mt-2 tw-text-sm">Click to upload logo</p>
                                                    <p className="tw-text-[10px] tw-text-gray-400">PNG / JPG • Max 2MB</p>
                                                </div>
                                            )}

                                            {/* File Input */}
                                            <input
                                                ref={fileInputRef}
                                                type="file"
                                                accept="image/png, image/jpg, image/jpeg"
                                                onChange={handleLogoUpload}
                                                className="tw-hidden"
                                                id="logo-uploader"
                                            />

                                            {/* CTA Button */}
                                            <label
                                                htmlFor="logo-uploader"
                                                className="tw-px-6 tw-py-2 tw-bg-green-600 tw-text-white tw-rounded-lg tw-text-sm tw-font-medium hover:tw-bg-green-700 tw-transition"
                                            >
                                                {logoPreview ? "Change Logo" : "Choose Logo"}
                                            </label>

                                            {/* Remove Button */}
                                            {logoPreview && (
                                                <button
                                                    onClick={removeLogo}
                                                    className="btn btn-secondary"
                                                >
                                                    Remove Logo
                                                </button>
                                            )}
                                        </div>

                                    </div>

                                    <div className="col-md-9">
                                        {/* RICH TEXT EDITOR */}
                                        <div>
                                            <h3 className="tw-text-xl tw-font-semibold tw-mb-4">Lab Name & Address (Right Side)</h3>

                                            <div className="tw-border tw-border-gray-300 tw-rounded-lg tw-overflow-hidden tw-shadow-sm">
                                                <ReactQuill
                                                    theme="snow"
                                                    value={headerText}
                                                    onChange={setHeaderText}
                                                    placeholder={`ClinicDots Diagnostic Center\n123, MG Road, Near City Hospital\nMumbai - 400001, Maharashtra\nPhone: +91 98765 43210 | Email: info@example.com\nNABL Accredited | ISO 9001:2015 Certified`}
                                                    className="tw-h-80 header-quill-editor"
                                                    modules={{
                                                        toolbar: [
                                                            [{ header: [1, 2, false] }],
                                                            ['bold', 'italic', 'underline'],
                                                            [{ align: [] }],
                                                            [{ list: 'ordered' }, { list: 'bullet' }],
                                                            ['clean']
                                                        ],
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* SAVE BUTTON */}
                                <div className="tw-text-right tw-mt-4">
                                    <button className="btn btn-primary" onClick={handelAdd}>
                                        Save Header Design
                                    </button>
                                </div>
                            </div>
                        </Card >
                    </Col>
                </Row>
            </Container>
        </>
    );
}